<template>
    <form method="POST"
          @submit="checkForm"
          action="/forms/newsletter">

        <input type="hidden" name="_token" v-bind:value="csrf">
        <input type="hidden" name="form-name" value="contact"/>

        <label for="name">Jouw naam</label>
        <input
            type="text"
            name="name"
            id="name"
            placeholder="Jouw naam"
            v-model="name"
            @keyup="checkName"
            v-bind:class="{ error: hasNameError, valid: nameIsValid }">

        <label for="email">E-mail</label>
        <input
            type="email"
            id="email"
            name="email"
            placeholder="naam@voorbeeld.nl"
            v-model="email"
            @keyup="checkEmail"
            v-bind:class="{ error: hasEmailError, valid: emailIsValid }">

        <div class="checkbox">
            <input
                type="checkbox"
                id="privacy"
                name="privacy"
                v-model="privacy"
                v-bind:class="{ error: hasPrivacyError, valid: privacyIsValid }"
                >
            <label for="privacy">
                Ik ga akkoord met de&nbsp;<a href="/privacyverklaring">privacyverklaring</a>
            </label>
        </div>

        <button type="submit" class="button">Ja, ik ontvang graag de Slimr<sup>®</sup> updates</button>
    </form>

</template>

<script>
    export default {
        data() {
            return {
                email: '',
                hasEmailError: false,
                emailIsValid: false,

                name: '',
                hasNameError: false,
                nameIsValid: false,

                privacy: '',
                hasPrivacyError: false,
                privacyIsValid: false,
            }
        },

        props: ['csrf', 'oldName', 'error'],

        mounted() {
            if (this.error !== 'false') {
                const kaas = document.querySelector('input[name=' + this.error + ']');
                kaas.classList.add("error");
            }
        },

        methods: {

            checkName() {
                this.hasNameError = !this.name;
                this.nameIsValid = this.name;
            },

            checkEmail() {
                this.hasEmailError = !this.validEmail(this.email);
                this.emailIsValid = this.email;
            },

            checkPrivacy() {
                this.hasPrivacyError = !this.privacy;
                this.privacyIsValid = this.privacy;
            },

            checkForm(e) {

                this.checkName();
                this.checkEmail();
                this.checkPrivacy();

                if (this.privacyIsValid &&
                    this.emailIsValid &&
                    this.nameIsValid) {
                    return true;
                }

                e.preventDefault();
            },

            validEmail(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
        }

    }
</script>
